import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useIntl } from "react-intl";

import "./NewWorkspaceFullpageLayout.scss";
import { workspaceSelectors } from "../../shared/layout/store/workspaceReducer";
import { authSelectors } from "../../auth/store/authReducer";
import { loadWorkspaces } from "../../shared/layout/store/workspaceActionCreators";
import { linkToNewChats } from "../../../routes";
import FastspringIntegration from "../../shared/FastspringIntegration";
import TrialExpiredDialog from "../../shared/trial-expired/TrialExpiredDialog";

const NewWorkspaceFullpageLayout = ({ children, contentPanelClassName = "" }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const intl = useIntl();
  const { workspaceId } = useParams();
  const workspaces = useSelector(workspaceSelectors.getWorkspaces);
  const workspace = useSelector(workspaceSelectors.getCurrent(workspaceId));
  const user = useSelector(authSelectors.getUser);
  const [showTrialExpired, setShowTrialExpired] = useState(false);

  useEffect(() => {
    if (!workspaces) {
      dispatch(loadWorkspaces(intl));
    }
    if (workspaces && workspaces.length > 0 && !workspace && !workspaceId) {
      navigate(linkToNewChats(workspaces[0].uid));
    }
  }, [workspaces, dispatch, workspace, workspaceId, navigate, intl]);

  const trialDaysLeft = user.subscription.daysLeft;

  useEffect(() => {
    if (trialDaysLeft === 0) {
      setShowTrialExpired(true);
    }
  }, [trialDaysLeft, setShowTrialExpired]);

  return (
    <div className="workspace_fullpage_layout">
      <div className={`content_panel ${contentPanelClassName}`}>
        {children}
      </div>
      <ToastContainer
        closeButton={true}
        className="notification-box"
        position="top-right"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
      />
      <FastspringIntegration />
      {showTrialExpired && <TrialExpiredDialog user={user} />}
    </div>
  );
};

export default NewWorkspaceFullpageLayout;
